/* eslint-disable jsx-a11y/label-has-associated-control */
import React from "react";
import { Modal, ModalBody } from "reactstrap";
import FormNuevaNP from "./FormNuevaNP";

const NuevaNotaFormModal = ({ history, toggle, isOpen, metaServicios, reloadNotas }) => {
  return (
    <div>
      <Modal isOpen={isOpen} style={{ fontFamily: "Nunito" }} size="lg">
        <div className="modal-header px-5" style={{ borderBottom: "none", background: " #f8f8f8" }}>
          <h5 className="modal-title">Nueva Nota de Pedido </h5>
        </div>
        <ModalBody style={{ background: " #f8f8f8" }}>
          <FormNuevaNP toggle={toggle} history={history} metaServicios={metaServicios} reloadNotas={reloadNotas} />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default NuevaNotaFormModal;
